/**
 * @flow
 * @relayHash 5e836b9ba93c430775991174f5def583
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type CreateJobPdfExportMutationVariables = {|
  input: {
    reportId?: ?string;
    exportId?: ?string;
    filename?: ?string;
    type?: ?string;
    from?: ?string;
    to?: ?string;
    devices?: ?$ReadOnlyArray<?string>;
    selectedTags?: ?$ReadOnlyArray<?string>;
    questionFilters?: ?$ReadOnlyArray<?{
      questionId?: ?string;
      options?: ?$ReadOnlyArray<?number>;
    }>;
    clientMutationId?: ?string;
  };
|};

export type CreateJobPdfExportMutationResponse = {|
  +createJobPdfExport: ?{|
    +job: ?{|
      +finishedOn: ?string;
      +processedOn: ?string;
      +id: string;
      +mongoId: ?string;
      +type: ?string;
      +jobId: ?number;
      +failedReason: ?string;
      +filename: ?string;
      +returnvalue: ?string;
    |};
  |};
|};
*/


/*
mutation CreateJobPdfExportMutation(
  $input: CreateJobPdfExportInput!
) {
  createJobPdfExport(input: $input) {
    job {
      finishedOn
      processedOn
      id
      mongoId
      type
      jobId
      failedReason
      filename
      returnvalue
    }
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "CreateJobPdfExportInput!",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateJobPdfExportMutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "CreateJobPdfExportInput!"
          }
        ],
        "concreteType": "CreateJobPdfExportPayload",
        "name": "createJobPdfExport",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Job",
            "name": "job",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "finishedOn",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "processedOn",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "mongoId",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "type",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "jobId",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "failedReason",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "filename",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "returnvalue",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "CreateJobPdfExportMutation",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "CreateJobPdfExportInput!",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "CreateJobPdfExportMutation",
    "operation": "mutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "CreateJobPdfExportInput!"
          }
        ],
        "concreteType": "CreateJobPdfExportPayload",
        "name": "createJobPdfExport",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Job",
            "name": "job",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "finishedOn",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "processedOn",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "mongoId",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "type",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "jobId",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "failedReason",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "filename",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "returnvalue",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "mutation CreateJobPdfExportMutation(\n  $input: CreateJobPdfExportInput!\n) {\n  createJobPdfExport(input: $input) {\n    job {\n      finishedOn\n      processedOn\n      id\n      mongoId\n      type\n      jobId\n      failedReason\n      filename\n      returnvalue\n    }\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// ./src/mutations/__generated__/CreateJobPdfExportMutation.graphql.js